import SelectRestaurant from "./selectRestaurant";

export default SelectRestaurant;
